<template>
  <div class="boarding">
    <div class="boarding__travel">
      <div style="background: #3BA46A">
        <div class="row q-py-sm q-pl-md" style="color: #fff">
          <div class="q-pt-sm">
            <q-icon name="watch_later" style="font-size:1.4em" class="q-pl-xs" />
          </div>
          <div class="column q-pl-sm text-caption">
            <span class="text-weight-bold q-pl-sm">Embarque em andamento</span>
            <span class="text-weight-regular q-pl-sm">
              Iniciado por:
              <span class="text-weight-bold text-capitalize">{{ user.toLowerCase() }}</span>
            </span>
          </div>
          <q-space></q-space>
          <div class="q-pr-sm q-pt-xs">
            <q-btn
              @click="confirmationCloseBoarding = true, showCameraButtonOnPassengers = false"
              no-caps
              unelevated
              label="Encerrar embarque"
              class="no-shadow text-weight-bold text-caption wrap"
              text-color="white"
              style="background-color: #DB1C1E; border-radius: 6px"
            />
          </div>
        </div>
      </div>

      <div class="travel__schedule">
        <div class="schedule__info">
          <div class="row q-py-sm">
            <div class="text-caption text-weight-bold">{{ cityToCamelCase(schedule.origin) }}</div>
            <q-icon v-if="schedule.destiny" name="arrow_forward" class="q-mx-sm" style="color: #37C100; font-size:1.5em" />
            <div class="text-caption text-weight-bold">{{ cityToCamelCase(schedule.destiny) }}</div>
          </div>
          <div class="info__bus">
            <q-icon name="directions_bus" style="font-size: 20px;" />

            <div class="text-uppercase text-caption">
              Carro
              <span class="info__bus--color">{{ schedule.number_bus }}</span>
            </div>
          </div>
        </div>

        <q-separator inset />
      </div>
      <div class="row">
        <div class="column q-pl-md q-py-sm">
          <span style="color: #7A8583; font-size: 10px">
            Saída dia
            <span class="text-weight-bold">{{ schedule.departure_travel | formatDate }}</span>
          </span>
          <span style="color: #7A8583; font-size: 10px">
            Saída da agência
            <span class="text-weight-bold">{{ schedule.departure | formatDate }}</span>
          </span>
          <span style="color: #7A8583; font-size: 10px">
            Saída da agência
            <span class="text-weight-bold">{{ schedule.alternative_agency }}</span>
          </span>
        </div>
        <q-space></q-space>
        <div class="q-pr-md q-pt-xs">
          <q-btn
            @click="getPassengers()"
            color
            class="text-black"
            icon="update"
            unelevated
            label="Atualizar"
          />
        </div>
      </div>
    </div>

    <div style="background-color: #F2F2F2;">
      <transition mode="out-in">
        <router-view />
      </transition>
    </div>

    <q-dialog
      v-model="confirmationCloseBoarding"
      @hide="showCameraButtonOnPassengers = true"
      persistent
      :maximized="true"
      transition-show="slide-up"
      transition-hide="slide-down"
      v-if="schedule !== null"
    >
      <q-card>
        <div
          class="row"
          style="background-color: #EEEFF2; border-radius: 0 0 40px 40px; height: 280px"
        >
          <div style="background: #0E4904" class="text-center q-pt-lg full-width">
            <span class="text-h6 text-weight-bold" style="color:#FFFFFF">DESEJA ENCERRAR O EMBARQUE?</span>
          </div>
          <div class="text-center full-width q-pt-lg">
            <q-separator inset class="q-my-sm" />
            <div class="text-weight-bold" style="color:#0E4904; font-size: 14px; line-height: 1">
              ESCOLHA O MOTIVO
              <br />DO ENCERRAMENTO
            </div>
            <q-separator inset class="q-my-sm" />
          </div>
          <div class="column q-gutter-x-md q-pl-md q-pb-md">
            <q-radio
              v-model="motiveOfClose"
              keep-color
              class="text-weight-bold"
              val="true"
              style="color: #0E4904"
              label="Passageiros embarcados - ônibus saindo."
            />
            <q-radio
              v-show="schedule.boarding_status !== 'concluido'"
              v-model="motiveOfClose"
              keep-color
              class="text-weight-bold"
              val="false"
              style="color: #0E4904"
              label="Embarque aberto por engano."
            />
          </div>
        </div>
        <div class="column q-py-lg q-px-xl">
          <span class="text-weight-bold" style="color: #172C20">RESUMO DA VIAGEM</span>

          <div class="row q-py-md" style="color: #172C20">
            <q-icon name="directions_bus" style="font-size:1.2em" />
            <span class="text-caption q-pl-xs">
              CARRO
              <span class="text-weight-bold">{{schedule.number_bus}}</span>
            </span>
          </div>

          <div class="row">
            <div
              class="text-subtitle2 text-weight-bold"
              style="color: #172C20"
            >{{ cityToCamelCase(schedule.origin) }}</div>
            <q-icon name="arrow_forward" class="q-mx-sm" style="color: #37C100; font-size:1.5em" />
            <div
              class="text-subtitle2 text-weight-bold"
              style="color: #172C20"
            >{{ cityToCamelCase(schedule.destiny) }}</div>
          </div>

          <div class="q-pt-sm" style="border-bottom: 1px solid #ECEDF2"></div>

          <div class="column q-pt-sm">
            <span class="text-caption" style="color: #014A19">
              Saída dia
              <span class="text-weight-bold">{{ schedule .departure_travel | formatDate }}</span>
            </span>
            <span class="text-caption" style="color: #014A19">
              Saída da agência
              <span class="text-weight-bold">{{ schedule.departure | formatDate }}</span>
            </span>
            <span class="text-caption" style="color: #014A19">
              Saída da agência
              <span class="text-weight-bold">{{ schedule.alternative_agency }}</span>
            </span>
          </div>

          <div class="fixed-bottom q-pb-md q-px-lg q-gutter-y-md">
            <q-btn
              @click="confirmationCloseBoarding = false"
              label="VOLTAR"
              unelevated
              outline
              class="text-weight-bold full-width"
              style="background: white; height: 50px; border-radius: 10px; color: #263A2D"
            />
            <q-btn
              @click="motiveOfClose === 'true' ? validCloseBoarding() : closeBoarding()"
              :disable="motiveOfClose ===  ''"
              label="ENCERRAR EMBARQUE"
              unelevated
              text-color="white"
              class="text-weight-bold full-width"
              style="background: #0E4904; height: 50px; border-radius: 10px"
            />
          </div>
        </div>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="dialogConfirmationCancelSeat"
      persistent
      :maximized="true"
      transition-show="slide-up"
      transition-hide="slide-down"
    >
      <q-card>
        <q-card-section>
          <div
            class="text-center text-weight-bold text-black q-pb-md"
            style="line-height: 1.2; font-size: 17px"
          >As seguintes poltronas serão desmarcadas e liberadas para venda</div>
          <div class="grid__passengers-title">
            <span>Poltronas</span>
            <span>Passageiros</span>
          </div>
          <q-list v-for="(p, index) in passengersListBoardingStatus" :key="index" class="q-pb-sm">
            <div class="grid__passengers row items-center">
              <div>
                <q-icon
                  name="airline_seat_recline_extra"
                  style="color: #808080; padding-right: 5px"
                />
                <span class="text-weight-bold">{{p.seat}}</span>
              </div>
              <span class="text-capitalize">{{p.name.toLowerCase()}}</span>
            </div>
            <q-separator></q-separator>
          </q-list>
        </q-card-section>
        <q-card-actions class="row justify-center q-gutter-lg absolute-bottom q-pb-lg">
          <div>
            <q-btn
              @click="dialogConfirmationCancelSeat = false"
              flat
              no-caps
              label="Cancelar"
              style="color:#808080; font-size: 15px"
              class="text-weight-bold"
            />
          </div>
          <div>
            <q-btn
              @click="closeBoarding()"
              unelevated
              no-caps
              label="Confirmar"
              class="no-shadow text-weight-bold text-caption wrap q-py-sm q-px-md"
              text-color="white"
              style="background-color: #0E4904; border-radius: 6px; font-size: 15px"
            />
          </div>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import {
  cityToCamelCase,
  formatDate,
  getSessionStorage,
  readBoardingQRCode,
  clearDate,
  setLocalStorage,
  getLocalStorage,
  getHost
} from "../../functions";
import {
  SELECTED_SCHEDULE,
  HISTORY_TRAVEL,
  DISEMBARK_LIST
} from "../../variables";
import { mutations, store } from "../../store";
import { USER } from "../../variables";

export default {
  filters: {
    formatDate
  },

  computed: {
    passengers: {
      get() {
        return store.passengers;
      },
      set(value) {
        mutations.setPassengers(value);
      }
    },
    passengersList: {
      get() {
        return store.passengersList;
      },
      set(value) {
        mutations.setPassengersList(value);
      }
    },
    passengersListBoardingStatus: {
      get () {
        return store.passengers.filter(v => !v.boarding_status)
      }
    },
    origin: {
      get() {
        return store.origin;
      }
    },
    showCameraButtonOnPassengers: {
      get() {
        return store.showCameraButtonOnPassengers;
      },
      set(value) {
        mutations.setShowCameraButtonOnPassengers(value);
      }
    }
  },

  data() {
    return {
      showPassengersList: false,
      schedule: {},
      user: "",
      confirmationCloseBoarding: false,
      boardingData: null,
      motiveOfClose: "",
      dialogConfirmationCancelSeat: false
    };
  },

  watch: {
    "$route.path": function(newVal) {
      this.setHeaderTitle(newVal);
    }
  },

  mounted() {
    this.setHeaderTitle(this.$route.path);
    this.schedule = getSessionStorage(SELECTED_SCHEDULE);
    this.user = getLocalStorage(USER).split(" ")[0];
    this.getPassengersList();
    this.getPassengersMounted();
  },

  methods: {
    readBoardingQRCode,
    cityToCamelCase,

    setHeaderTitle(route) {
      var header;
      if (route === "/embarque") {
        header = "Realizar embarque";
      } else if (route === "/embarque/passageiros") {
        header = "Embarque";
      } else if (route === "/voucher") {
        header = "Emitir BPE Pendentes";
      } else {
        header = "Conferência de embarque";
      }
      mutations.setHeaderTitle(header);
    },

    validCloseBoarding() {
      for (const i in this.passengers) {
        if (this.passengers[i].boarding_status === false) {
          this.dialogConfirmationCancelSeat = true;
          return;
        }
      }
      this.closeBoarding();
    },

    closeBoarding() {
      let struct = {
        travel_id: this.schedule.travel_id,
        boarding_close: this.motiveOfClose,
        id: this.schedule.id
      };

      window.http
        .post(`${getHost()}/eucaturmobile/boarding/close`, struct)
        .then(r => {
          if (r.status === 204) {
            mutations.openAlert({
              open: true,
              message:
                "Para cancelar embarque por engano antes desembarque todos os passageiros.",
              status: 400
            });

            return;
          }

          let structHistory = {
            travel_id: this.schedule.travel_id,
            secc_place: this.origin ? this.origin.code : this.schedule.boarding_code
          };

          window.http
            .get(`${getHost()}/eucaturmobile/history-travel`, structHistory)
            .then(r => {
              setLocalStorage(HISTORY_TRAVEL, r.data);
            });

          window.http
            .get(`${getHost()}/eucaturmobile/disembark`, structHistory)
            .then(r => {
              setLocalStorage(DISEMBARK_LIST, r.data);
            });

          this.passengers = [];
          this.$router.push({ path: "/pesquisar" });
        });
    },

    getPassengers() {
      const departure = clearDate(this.schedule.departure);
      const departureTravel = clearDate(this.schedule.departure_travel);

      const uri =
        `${getHost()}/eucaturmobile/passengers` +
        `?code=${this.schedule.boarding_code}&line=${this.schedule.line}` +
        `&departure=${departure}&departure_travel=${departureTravel}` +
        `&direction=${this.schedule.direction}` +
        `&alternative_code=${this.schedule.boarding_alternative_code}`;

      window.http.get(uri).then(response => {
        if (response.data.message === undefined) {
          mutations.openAlert({
            open: true,
            message: "Lista de passageiros atualizada",
            status: 200
          });
          this.passengers = response.data;
        }
      });
    },

    getPassengersMounted() {
      const departure = clearDate(this.schedule.departure);
      const departureTravel = clearDate(this.schedule.departure_travel);

      const uri =
        `${getHost()}/eucaturmobile/passengers` +
        `?code=${this.schedule.boarding_code}&line=${this.schedule.line}` +
        `&departure=${departure}&departure_travel=${departureTravel}` +
        `&direction=${this.schedule.direction}` +
        `&alternative_code=${this.schedule.boarding_alternative_code}`;

      window.http.get(uri).then(response => {
        if (response.data.message === undefined) {
          this.passengers = response.data;
        }
      });
    },

    getPassengersList() {
      const departure = clearDate(this.schedule.departure);
      const departureTravel = clearDate(this.schedule.departure_travel);

      const uri =
        `${getHost()}/eucaturmobile/passengers/list` +
        `?code=${this.schedule.boarding_code}&line=${this.schedule.line}` +
        `&departure=${departure}&departure_travel=${departureTravel}` +
        `&direction=${this.schedule.direction}` +
        `&alternative_code=${this.schedule.boarding_alternative_code}`;

      window.http.get(uri).then(response => {
        if (response.data.message === undefined) {
          this.passengersList = response.data;
        }
      });
    }
  }
};
</script>

<style lang="scss">
$icon-size: 70px;

%city-circle {
  $size: 12px;

  display: block;
  width: $size;
  height: $size;
  border-radius: 50%;
}

%city-grid {
  display: grid;
  grid-column-gap: 8px;
  grid-template-columns: max-content 1fr;

  align-items: center;
  font-weight: 500;
}

%options-style {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px 0;
}

%options-grid {
  display: grid;
  grid-row-gap: 5px;

  width: 80%;
  margin: auto;
}

%options-title {
  font-size: 1rem;
  line-height: normal;
  color: #092c1e;
  text-transform: uppercase;

  margin: 0;
}

%options-subtitle {
  font-size: 0.8rem;
  color: #7a8583;
  line-height: normal;
}

.boarding {
  display: grid;
  grid-template-rows: max-content 1fr;
  height: 100vh;
}

.boarding__travel {
  display: grid;

  background-color: #ffffff;
  box-shadow: 0 3px 4px 0 #eeeff295;

  .travel__header {
    display: grid;
    grid-template-columns: max-content 1fr max-content;
    grid-template-rows: 80px;

    place-items: center;
  }

  .travel__header--style {
    font-size: 1rem;
    font-weight: 600;
    text-transform: uppercase;
  }

  .travel__schedule {
    display: grid;
    grid-row-gap: 8px;
    grid-template-rows: max-content;
    justify-items: center;

    .schedule__info {
      display: grid;
      width: 90%;

      .info__bus {
        display: grid;
        grid-column-gap: 4px;
        grid-template-columns: repeat(2, max-content);

        place-items: center;
        margin-bottom: 8px;
        margin-left: -4px;
      }

      .info__bus--color {
        color: #172c20;
        font-weight: 600;
      }

      .circle-origin {
        background-color: #7a8583;
        @extend %city-circle;
      }

      .circle-destiny {
        background-color: #20c600;
        @extend %city-circle;
      }

      .info__origin {
        color: #707070;
        @extend %city-grid;
      }

      .info__destiny {
        color: #040006;
        @extend %city-grid;
      }
    }
  }

  .travel__departure {
    display: grid;
    width: 90%;
    margin: 15px auto;

    .departure__travel,
    .departure__agency {
      display: grid;
      grid-template-columns: repeat(2, max-content);

      color: #7a8583;
    }

    .departure--semi-bold {
      font-weight: 600;
    }
  }
}

.boarding__options {
  display: grid;

  grid-column-gap: 10px;
  grid-row-gap: 8px;

  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "title title"
    "qr-code list";

  width: 90%;
  margin: auto;
}

.boarding__other-options {
  display: grid;
  grid-row-gap: 16px;
  grid-template-rows: max-content;

  width: 90%;
  margin: auto;

  .other-options__title {
    @extend %options-title;
    font-weight: 600;
    color: #000000;
  }

  .other-options__btn {
    background-color: #ffffff;
  }
}

.grid__passengers-title {
  display: grid;
  grid-template-columns: 1fr max-content;
  gap: 20px;
  padding-bottom: 10px;
}
.grid__passengers {
  display: grid;
  grid-template-columns: 1fr max-content;
}
</style>

